/**
 * Electron Renderer 環境別設定ファイル
 * firebaseConfig_tickets.jsと同じ環境判定ロジックを使用
 */

const isProductionBuild = process.env.NODE_ENV === 'production';

// 実行時に環境を判定（firebaseConfig_tickets.jsと同じロジック）
const getEnvironment = () => {
  // デバッグ用ログ
  if (typeof window !== 'undefined' && window.location) {
    console.log('[config.js] window.location.hostname:', window.location.hostname);
    console.log('[config.js] window.location.port:', window.location.port);
    console.log('[config.js] window.location.protocol:', window.location.protocol);
  }
  
  // ビルド時の環境変数をチェック（Parcelがビルド時に文字列リテラルに置換）
  // process.env.REACT_APP_ENV は Parcel によって "prd" または "dev" に置換される
  const buildEnv = process.env.REACT_APP_ENV;
  if (buildEnv) {
    console.log('[config.js] Using REACT_APP_ENV:', buildEnv);
    return buildEnv;
  }
  
  // ホスト名で判定（Web版）
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    const port = window.location.port;
    const protocol = window.location.protocol;
    
    // 本番環境のホスト名
    if (hostname === 'ticketsystem-4bc88.web.app' || hostname === 'ticketsystem-4bc88.firebaseapp.com') {
      console.log('[config.js] Using prd based on hostname:', hostname);
      return 'prd';
    }
    
    // 開発サーバー（ポート3000）
    if (hostname === 'localhost' && port === '3000') {
      console.log('[config.js] Using dev based on port 3000');
      return 'dev';
    }
    
    // Electron本番ビルド判定
    // - file:// プロトコル（パッケージ版）
    // - hostname が空文字列
    if (protocol === 'file:' || hostname === '') {
      console.log('[config.js] Using prd for Electron production build');
      return 'prd';
    }
  }
  
  // デフォルトは開発環境
  console.log('[config.js] Using default: dev');
  return 'dev';
};

const env = getEnvironment();
const firestoreDatabaseId = env === 'prd' ? 'prd-firebase-store' : 'dev-firebase-store';

console.log('[config.js] Environment:', env, 'Database:', firestoreDatabaseId);

// 環境別設定（実行時の環境に基づく）
// Stripeダッシュボードから取得した公開可能キー
const STRIPE_PUBLISHABLE_KEY_LIVE = 'pk_live_51T7SioIvYgXOkNijXi49BLd46H0ubw44m5bYdRwIb70Py5pcjMgp8T8Amsh36QLtlYlddUlWjIMEXddvFNRRJL1x00XoAzVaf4'; // TODO: 本番環境の公開可能キーに置き換え
const STRIPE_PUBLISHABLE_KEY_TEST = 'pk_test_51T7SiyEWMg5HCxyO5v9kpUT3Ya9SwPot6l1KVvGkdJHPpr3uYVpT37YMXFeBuzzOueB5GZ6Lg9zmYWVQpjgDcSg200J4uWsZtX';

const stripePublishableKey = env === 'prd' ? STRIPE_PUBLISHABLE_KEY_LIVE : STRIPE_PUBLISHABLE_KEY_TEST;

// プラットフォームIDの決定
// 環境変数が指定されていなければ、簡易的なOS判定を行う
let platformId = process.env.REACT_APP_PLATFORM_ID || '';

// 空文字列の場合も再判定
if (!platformId) {
  if (typeof window !== 'undefined' && window.navigator) {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf('Win') !== -1) platformId = 'WIN';
    else if (userAgent.indexOf('Mac') !== -1) platformId = 'MAC';
    else if (userAgent.indexOf('Linux') !== -1) platformId = 'LINUX';
    else platformId = 'WEB';
  } else {
    platformId = 'WEB';
  }
}

console.log('[config.js] Platform ID:', platformId);
console.log('[config.js] Stripe key prefix:', stripePublishableKey.substring(0, 15));

export const config = {
  isProduction: isProductionBuild,
  isDevelopment: !isProductionBuild,
  environment: env,
  platformId,
  stripePublishableKey,
  firestoreDatabaseId,
};

export default config;
